export default {
  data() {
    return {
      moreBtnHeight: {},
      moreBtnLabel: {},
    };
  },
  computed: {
    isShowMoreBtn() {
      return (slug) => {
        return ((this.moreBtnLabel[slug] || '').toString().length === 0);
      };
    },
  },
  methods: {
    toggleMoreBtnClicked(slug, count) {
      let optionsWrapper = null;
      if (window.innerWidth >= 768) {
        optionsWrapper = this.$refs[`optionsWrapper${slug}`][0].$el;
      } else {
        optionsWrapper = this.$refs[`optionsWrapperMobile${slug}`][0];
      }

      if (optionsWrapper) {
        if (this.moreBtnHeight[slug]) {
          optionsWrapper.style.height = this.moreBtnHeight[slug];
          this.moreBtnHeight[slug] = null;
          this.moreBtnLabel = {
            ...this.moreBtnLabel,
            [slug]: null
          };
        } else {
          const height = ((parseInt(count, 10)) * 42) + 26;
          this.moreBtnHeight[slug] = optionsWrapper.style.height;
          this.moreBtnLabel = {
            ...this.moreBtnLabel,
            [slug]: slug
          };
          optionsWrapper.style.height = `${height}px`;
        }
      }
    },
  },
};
